var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fz-list"},_vm._l((_vm.blocks),function(b,i){return _c('a',{key:i,staticClass:"block",attrs:{"target":b.mod_name?'_blank':'_self',"href":b.mod_name?`https://fangzhen.rpazj.com/#/${b.mod_name}`:'javascript:;'}},[_c('img',{attrs:{"src":require(`@/assets/images/${b.pic}`)}}),_c('span',[_vm._v(_vm._s(b.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }